import 'intl-pluralrules';
import { isServer } from '@flyer/utils';
import { install } from 'resize-observer';

if (!isServer()) {
  install();
}
